import { Image, Text, View } from '@react-pdf/renderer'
import PDFPage from '@/components/ReportPDF/PDFPage'
import PDFParagraph from '@/components/ReportPDF/PDFParagraph'

const Chapter4Sub3Page = ({ chartImg3, setPage, reportData }) => (
  <PDFPage hideTitleDivider reportData={reportData}>
    <Text
      render={({ pageNumber }) => {
        setPage({ chap4_2: pageNumber })
      }}
    />
    <View>
      <PDFParagraph>
        {'    '}依照人數統計之
        <Text>「瀏覽郵件」、「點閱連結」、「開啟附件」與「輸入資料」</Text>
        之人數統計直條圖表：
      </PDFParagraph>
      {chartImg3 && <Image src={chartImg3} />}
    </View>
  </PDFPage>
)

export default Chapter4Sub3Page
